import React, { ReactElement, useCallback, useMemo, useState } from "react";
import { AccordionItemProps } from "./AccordionItem";
import styles from "./Accordion.module.scss";
import clsx from "clsx";

type AccordionProps = {
  children: ReactElement<AccordionItemProps>[];
  className?: string;
  trackingName: string;
};

export const Accordion: React.FC<AccordionProps> = ({
  className,
  trackingName,
  children
}) => {
  const [expandedItem, setExpandedItem] = useState<string | undefined>(
    undefined
  );

  const toggleExpanedItem = useCallback(
    (key: string | undefined) => {
      if (expandedItem == key) setExpandedItem(undefined);
      else setExpandedItem(key);
    },
    [expandedItem]
  );

  const childrenWithProps = useMemo(
    () =>
      React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          const isExpanded = expandedItem == child.props.id;

          return React.cloneElement(child, {
            onToggleExpanedItem: toggleExpanedItem,
            isExpanded
          });
        }
      }),
    [children, expandedItem, toggleExpanedItem]
  );

  return (
    <div
      data-content-name={trackingName}
      className={clsx(styles.wrapper, className)}
    >
      {childrenWithProps}
    </div>
  );
};
